import { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useAuthStore } from "@/lib/store";
import AdminSidebar from "@/components/admin/AdminSidebar";
import toast from "react-hot-toast";

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useAuthStore();

  // Skip auth check for login page
  const isLoginPage = location.pathname === "/admin/login";

  useEffect(() => {
    // Don't check authentication on login page
    if (isLoginPage) {
      return;
    }

    if (!isAuthenticated) {
      navigate("/admin/login");
      return;
    }
    // Check if user is admin or superadmin
    if (user?.role !== "admin" && user?.role !== "superadmin") {
      toast.error("Access denied. Admin privileges required.");
      navigate("/");
      return;
    }
  }, [isAuthenticated, navigate, user, isLoginPage, location.pathname]);

  // Don't render sidebar on login page
  if (isLoginPage) {
    return <Outlet />;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar />
      <main className="flex-1 overflow-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  );
}
